var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sc-form", {
    staticClass: "box is-paddingless",
    attrs: { form: _vm.quotingReturns, rules: _vm.rules },
    on: { submit: _vm.save },
    scopedSlots: _vm._u([
      {
        key: "fields",
        fn: function(ref) {
          var fields = ref.fields
          return [
            _c("div", { staticClass: "columns" }, [
              _c(
                "div",
                { staticClass: "column is-6" },
                [
                  _c(
                    "sc-field",
                    {
                      attrs: {
                        label: "Gostaria de esconder os valores duplicados",
                        prop: "duplicates"
                      }
                    },
                    [
                      _c(
                        "sc-switch",
                        {
                          model: {
                            value: fields.duplicates,
                            callback: function($$v) {
                              _vm.$set(fields, "duplicates", $$v)
                            },
                            expression: "fields.duplicates"
                          }
                        },
                        [_vm._v("\n                Sim\n              ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "columns" }, [
              _c(
                "div",
                { staticClass: "column is-4" },
                [
                  _c(
                    "sc-field",
                    { attrs: { label: "Condições", prop: "sort_type_id" } },
                    [
                      _c(
                        "sc-select",
                        {
                          attrs: { expanded: "" },
                          model: {
                            value: fields.sort_type_id,
                            callback: function($$v) {
                              _vm.$set(fields, "sort_type_id", $$v)
                            },
                            expression: "fields.sort_type_id"
                          }
                        },
                        _vm._l(_vm.srcSortType, function(item) {
                          return _c(
                            "option",
                            { key: item.id, domProps: { value: item.id } },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(item.text) +
                                  "\n                  "
                              )
                            ]
                          )
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "columns" }, [
              _c(
                "div",
                { staticClass: "column is-4" },
                [
                  _c(
                    "sc-field",
                    { attrs: { label: "Ordem", prop: "sort_mode" } },
                    [
                      _c(
                        "sc-select",
                        {
                          attrs: { expanded: "" },
                          model: {
                            value: fields.sort_mode,
                            callback: function($$v) {
                              _vm.$set(fields, "sort_mode", $$v)
                            },
                            expression: "fields.sort_mode"
                          }
                        },
                        _vm._l(_vm.srcSortMode, function(item) {
                          return _c(
                            "option",
                            { key: item.id, domProps: { value: item.value } },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(item.text) +
                                  "\n                  "
                              )
                            ]
                          )
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "columns" }, [
              _c(
                "div",
                { staticClass: "column is-12 has-text-right" },
                [
                  _c("sc-button", {
                    attrs: { type: "submit", theme: "primary", text: "Salvar" }
                  })
                ],
                1
              )
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e5e5d74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e5e5d74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/quoting-return/components/sc-quoting-return-all/ScQuotingReturnAll.vue
// module id = null
// module chunks = 